import { Axios } from 'utils/AxiosConfig'

export const postCalculatePaidService = async (payload) => {
  const { data: response } = await Axios.post(`member/paid-service/calculate`, payload)
  return response
}
export const postCheckoutPaidService = async (payload) => {
  const { data: response } = await Axios.post(`member/paid-service`, payload)
  return response
}

export const getSponsorship = async (role) => {
  const { data: response } = await Axios.get(`member/sponsorship/list/${role}`)
  return response
}